import { apiFetch, ApiFetchOptions } from './genericApi'
import { getInstanceIdFromUrl } from './getInstanceIdFromUrl'
import { isString } from './isString'

export async function getIamAccount(
  resource: string,
  options?: ApiFetchOptions,
): Promise<unknown> {
  const id = getInstanceIdFromUrl()
  if (!isString(id)) {
    return null
  }
  return getIamRoot(
    `instances/${id}${isString(resource) ? `/${resource}` : ''}`,
    options,
  )
}

export async function getIamRoot(
  resource: string,
  options?: ApiFetchOptions,
): Promise<unknown> {
  return apiFetch(`iam/${resource}`, options)
}
